export default __webpack_public_path__ + "static/media/banner02.daec9768.png";